import React from 'react';
import mixpanel from 'mixpanel-browser';

import './StartTrialAction.scss';

import Button from '../Button';

function StartTrialAction(props) {

  const goToSignUp = () => {
    mixpanel.track('Blog Action: Start Trial Clicked - In-Page');
    window.open(process.env.REACT_APP_SIGNUP_BASE_URL, '_blank');
  }

  return (
    <div className="start-trial-action">
      <div className="image"></div>
      <div className="details">
        <p className="title">Try our award-winning<br className="show-for-medium" /> app free for 7 days</p>
        <p className="subtitle">Just $9.99/month after. Cancel anytime.</p>
        <Button text="Start your free trial" type="in-page" onClick={goToSignUp} />
      </div>
    </div>
  );
}

export default StartTrialAction;
